import React from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

interface LabelProps  {
  name?: string;
  label?: string;
  required?: boolean;
  className?: string;
}
const Label = ({ name, label, required, className }: LabelProps) => (
    <label htmlFor={name} className={cn(styles.label, className)}>
        {label}
        {required && label && <i className={styles.required}>*</i>}
    </label>
);

export default Label;
